module.exports = __webpack_public_path__ + "img/x-diamond-fill.13bb9fa1.svg";